import { GroupMembers } from './group-members.model';
import { GroupMember } from './group-member.model';

/**
 * Combines the actual WardGroup with students assigned to it.  For ease of making assignments in the UI.
 */
export class GroupMembersCollection {
  title: string;
  id?: number;
  members: GroupMembers[];

  selectedMembers: GroupMember[];

  constructor(title: string, id?: number) {
    this.title = title;
    this.id = id;
    this.members = [];
  }
}
